import React from 'react';

import { SortingProvider } from './context';
import { useSortingSearchParams } from './searchParams';

export type SortingSearchParamKeyProps = {
  sortByKey?: string;
  initialSort?: {
    column: string;
    descending?: boolean;
  };
};

/**
 * A provider that stores the sorting state in the URL search params.
 */
export const DefaultSortingProvider: React.FC<SortingSearchParamKeyProps> = ({
  sortByKey = 'orderBy',
  initialSort,
  children,
}) => {
  const value = useSortingSearchParams(sortByKey, initialSort);
  return <SortingProvider value={value}>{children}</SortingProvider>;
};
